import { BriefService } from "@entities/brief/lib/services/brief.service";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { ICampaignPendingReviewActionCount } from "@shared/lib/types/briefCampains";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_CAMPAIGN_PENDING_REVIEW_QUERY_KEY } from "../contsants";

export type CampaignPendingReviewActionCounts = {
  brand: ICampaignPendingReviewActionCount;
  agency: ICampaignPendingReviewActionCount;
};

export function useGetCampaignPendingReviewActionCount(briefId: string) {
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<CampaignPendingReviewActionCounts>
  >({
    queryKey: BRIEF_CAMPAIGN_PENDING_REVIEW_QUERY_KEY(briefId),
    queryFn: () =>
      BriefService.getCampaignPendingReviewActionCounts(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    pendingReviewCounts: data?.data,
    isFetching: isLoading,
  };
}
